import Vue from "vue";
import App from "./App.vue";
import "./plugins/axios";
import "babel-polyfill";
import store from "./store";
Vue.config.productionTip = false;

// fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { faX } from "@fortawesome/free-solid-svg-icons";
library.add(faUserSecret, faX);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

// quillEditor
import { quillEditor } from "vue3-quill";
Vue.use(quillEditor);

// google GA4 tag 등록
import VueGtag from "vue-gtag";
import VueTagManager from "vue-tag-manager";
import VueHead from "vue-head";

// meta tag
import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  keyName: "metaInfo",
  ssrAttribute: "data-vue-meta-server-rendered",
  refreshOnceOnNavigation: true,
});

// 캐럿 글로벌, 솔루션즈
import carrotglobal from "./route/carrotglobal";
import carrotenglish from "./route/carrotenglish";

// 랜딩
import mangolanding from "./route/mangolanding";
import carrotchinese from "./route/carrotchinese";
import aitutoring from "./route/aitutoring";

// 게이트
import gijangcamp from "./route/gijangcamp";
import skbioscience from "./route/skbioscience";
import jinjuenglish from "./route/jinjuenglish";
import ongjinenglish from "./route/ongjinenglish";
import anyangenglish from "./route/anyangenglish";
import hscarrot from "./route/hscarrot";
import asyouthenglish from "./route/asyouthenglish";
import uljinenglish from "./route/uljinenglish";

// 컨퍼런스
import conf2024 from "./route/conf2024";

// 리로케이션
import expatcare from "./route/expatcare";

const host = window.location.href;
const domain = new URL(host).hostname;
let routes;
if (
  // 캐럿글로벌
  domain == "carrotglobal.com" ||
  domain == "www.carrotglobal.com" ||
  domain == "stage-biz.carrotglobal.com"
) {
  routes = carrotglobal;
} else if (
  // 캐럿솔루션즈
  domain == "carrotenglish.com" ||
  domain == "biz.carrotenglish.com" ||
  domain == "stage-biz.carrotenglish.com"
) {
  routes = carrotenglish;
} else if (
  // 망고톡
  domain == "mangotalk.co.kr" ||
  domain == "www.mangotalk.co.kr" ||
  domain == "stage.mangotalk.co.kr"
) {
  routes = mangolanding;
} else if (
  // 당근중국어
  domain == "carrotchinese.co.kr" ||
  domain == "www.carrotchinese.co.kr" ||
  domain == "stage.carrotchinese.co.kr" ||
  domain == "carrotchinese.com" ||
  domain == "www.carrotchinese.com" ||
  domain == "stage.carrotchinese.com"
) {
  routes = carrotchinese;
} else if (
  // ai 튜터
  domain == "aitutoring.co.kr" ||
  domain == "www.aitutoring.co.kr" ||
  domain == "stage.aitutoring.co.kr"
) {
  routes = aitutoring;
} else if (
  // 기장
  domain == "gijangcamp.co.kr" ||
  domain == "www.gijangcamp.co.kr" ||
  domain == "stage.gijangcamp.co.kr"
) {
  routes = gijangcamp;
} else if (
  // sk
  domain == "carrotskbiosc.co.kr" ||
  domain == "www.carrotskbiosc.co.kr" ||
  domain == "stage.carrotskbiosc.co.kr"
) {
  routes = skbioscience;
} else if (
  // 진주
  domain == "jinjuenglish.com" ||
  domain == "www.jinjuenglish.com" ||
  domain == "life.jinjuenglish.com"
) {
  routes = jinjuenglish;
} else if (
  // 옹진
  domain == "ongjinenglish.com" ||
  domain == "www.ongjinenglish.com"
) {
  routes = ongjinenglish;
} else if (
  // 안양
  domain == "anyangenglish.com" ||
  domain == "www.anyangenglish.com" ||
  domain == "localhost"
) {
  routes = anyangenglish;
} else if (
  // 화성
  domain == "hscarrot.co.kr" ||
  domain == "www.hscarrot.co.kr"
) {
  routes = hscarrot;
} else if (
  // 아산
  domain == "asyouthenglish.com" ||
  domain == "www.asyouthenglish.com"
) {
  routes = asyouthenglish;
} else if (
  // 컨퍼런스
  domain == "conf2024.carrotglobal.com" ||
  domain == "stage-conf2024.carrotglobal.com"
) {
  routes = conf2024;
} else if (
  // 리로케이션
  domain == "expatcare.co.kr" ||
  domain == "www.expatcare.co.kr" ||
  domain == "stage.expatcare.co.kr"
) {
  routes = expatcare;
} else if (
  // 울진
  domain == "uljinenglish.com" ||
  domain == "www.uljinenglish.com"
) {
  routes = uljinenglish;
}

Vue.use(VueHead);

// 캐럿글로벌
Vue.use(VueGtag, {
  config: {
    id: "G-M1FBGF5Z7C",
    params: {
      send_page_view: false,
      linker: {
        domains: ["www.carrotglobal.com", "carrotglobal.com"],
      },
    },
  },
  enabled:
    window.location.hostname === "www.carrotglobal.com" ||
    window.location.hostname === "carrotglobal.com",
});

// 당근중국어
Vue.use(VueGtag, {
  config: {
    id: "GTM-KLVFDPT6",
  },
  enabled:
    window.location.hostname === "carrotchinese.com" ||
    window.location.hostname === "www.carrotchinese.com" ||
    window.location.hostname === "carrotchinese.co.kr" ||
    window.location.hostname === "www.carrotchinese.co.kr",
});
Vue.use(VueTagManager, {
  gtmId: "GTM-KLVFDPT6",
  isEnabled:
    window.location.hostname === "carrotchinese.com" ||
    window.location.hostname === "www.carrotchinese.com" ||
    window.location.hostname === "carrotchinese.co.kr" ||
    window.location.hostname === "www.carrotchinese.co.kr",
});

new Vue({
  router: routes,
  store,
  render: (h) => h(App),
}).$mount("#app");
